import EmployeeDetails from "../../../../components/company/workforce/onboarding/employee-details";


const EmployeeDetailsPage = () => {
    return <EmployeeDetails/>
}

export default EmployeeDetailsPage;